<template>
  <b-tooltip
    :show="showTooltip"
    :target="validationContext.input.id" triggers=""
    :placement="placement" boundary="viewport">
    {{validationContext.validationMessage}}
  </b-tooltip>
</template>

<script>

/**
 * Componente tooltip específico para validação de campos, reage as modificações do modelo
 * do vuelidate. o tooltip é exibido se a mensagem de validação não estiver vazia e o componente
 * estiver em estado de erro, que ocorre após o foco deixar o campo.
 *
 * @example
 * <s-input-validation
 *  :validationContext="nameValidationContext"/>
 *
 * @param {Object} validationContext Objeto de contexto usado para resgatar a mensagem,
 * modelo do vuelidate e o target do componente (id). Ele deve seguir a seguinte estrutura:
 * {
 *   validationMessage: String
 *   validationModel: Object Objeto de contexto da validação do vuelidate ex. this.$v.name
 *   input: {
 *     id: String
 *   }
 * }
 *
 * Este componente tem seu uso facilitado usando o helper createValidationContext
 *  importado através do arquivo @/service/validationHelper
 */
export default {
  props: {
    validationContext: {
      type: Object,
      default: () => ({
        validationMessage: null,
        validationModel: null,
        input: {
          target: null,
        },
      }),
    },
    placement: {
      type: String,
      default: 'right',
    },
  },
  computed: {
    showTooltip() {
      return this.validationContext.validationMessage
        && this.validationContext.validationModel.$error;
    },
  },
};

</script>
